import request from './request'

export function getTiposDeLote(){
    return request({
        url:'/utilidades/tiposdelote/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getEstadoConcursos(){
    return request({
        url:'/utilidades/estadosconcurso/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getEstadoLotes(){
    return request({
        url:'/utilidades/estadolotes/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getEstadoLotesOfertados(){
    return request({
        url:'/utilidades/estadolotesofertados/all',
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function cambiarContraseña(oldPass, newPass){
    return request({
        url:'/usuarios/contrasena?email=' + encodeURIComponent(localStorage.getItem("email")) + '&viejaContrasena=' + encodeURIComponent(oldPass) + '&nuevaContrasena=' + encodeURIComponent(newPass),
        method:'PUT',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function cambiarUsuario(email, nombre, apellido, pass){
    return request({
        url:'/usuarios/nombreYapellido?email=' + encodeURIComponent(email) + '&nombre=' + encodeURIComponent(nombre) + '&apellidos=' + encodeURIComponent(apellido) + '&contrasena=' + encodeURIComponent(pass),
        method:'PUT',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}

export function getNombreApellidos(){
    return request({
        url:'/usuarios/nombreYapellido?email=' + encodeURIComponent(localStorage.getItem("email")),
        method:'GET',
        headers: { authorization: "Bearer " + localStorage.getItem("accessToken") },
    })
}